module.exports = __webpack_public_path__ + "static/media/governance.90c4ebf8.svg";